// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-components-FilterManager-FiltersButton-module__activeFilterCounter__pHp2T";
var _2 = "assets-js-GalleryPB-components-FilterManager-FiltersButton-module__filtersButtonActive__sOVYk";
export { _1 as "activeFilterCounter", _2 as "filtersButtonActive" }
